import { useDispatch, useSelector } from 'react-redux';
import { getPlotStepData, plotStepData, plotStepsActions } from 'widgets/PlotSteps';
import { classNames } from 'shared/lib/classNames/classNames';
import { Buttons } from '../Buttons';
import { useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Navigate, useNavigate } from 'react-router-dom';
import { useApi } from 'app/api/APIProvider';
import cls from './MoneyView.module.scss';

interface MoneyViewProps {
    className?: string
}
export const MoneyView = (props: MoneyViewProps) => {
    const {
        className,
    } = props;
    const stepData = useSelector(getPlotStepData);
    const [isDisabledButton, setIsDisabledButton] = useState<boolean>(false);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const api = useApi();

    const nextStepHandler = (linkOnStep: number) => {
        const user = api.User;
        const currentStep = user.current_scene.plotStep;

        api.EditUser({
            current_scene: {
                plotStep: linkOnStep,
                previousStep: currentStep,
            },
        }).then(() => {
            user.current_scene = {
                plotStep: linkOnStep,
                previousStep: currentStep,
            };

            setTimeout(() => {
                dispatch(plotStepsActions.addedPlotStepData(plotStepData(linkOnStep, user, {})));
                setIsDisabledButton(false);
            }, 500);
        })
    };

    const getFinalSum = async (button?: any) => {
        const {outcome, income, result} = await api.getFinalSum();
        sessionStorage.setItem('outcomeSum', outcome);
        sessionStorage.setItem('incomeSum', income);
        // sessionStorage.setItem('result', result);
        if (button.linkOnStep === 133) {
            await api.CancelAll();
        }
        const { wallet } = await api.GetAllSum();
        sessionStorage.setItem('result', String(wallet));
        const plotOptions = {
            wallet,
        };
        nextStepHandler(button.linkOnStep);
        sessionStorage.removeItem('credit');
    };

    return (
        <div className={classNames(cls.MoneyView, {}, [className])}>
            <div className={`${cls.speaker} ${cls.imgBox}`}>
                <img className={cls.speakerImg} src={stepData?.action?.moneyView?.speakerImg} alt="Персонаж" />
            </div>
            <div className={cls.actionContent}>
                <img className={cls.img} src={stepData?.action?.moneyView?.img} alt="Деньги" />
                <div className={cls.text}>
                    {stepData?.action?.moneyView?.text}
                </div>
                <Buttons />
            </div>
            <Button
                className={cls.nextButton}
                theme={ButtonTheme.NEXT}
                disabled={isDisabledButton}
                onClick={() => {
                    setIsDisabledButton(true);
                    switch (true) {
                        case stepData.needFinalSum:
                            getFinalSum(stepData?.action?.extraButton);
                            break;
                        default:
                            nextStepHandler(stepData?.action?.extraButton.linkOnStep);
                        }
                }}
            >
                Далее
            </Button>
        </div>
    );
};
